/**
 * The once-per-browser marker (U6).
 *
 * Soft by design and labelled so in the builder: a localStorage flag written
 * after a successful submit, read on the next visit to show the duplicate
 * message instead of the form. Anyone can clear it or open another browser;
 * the hard check is once-per-email on the server. Same `fm-*` prefix and
 * try/catch discipline as the draft autosave (resume.ts) — some browsers
 * throw on localStorage and a respondent must never see that.
 */

const key = (formPath: string) => `fm-sent:${formPath}`;

export function markSent(formPath: string): void {
  try { localStorage.setItem(key(formPath), String(Date.now())); } catch { /* private mode etc. */ }
}

export function wasSent(formPath: string): boolean {
  try { return !!localStorage.getItem(key(formPath)); } catch { return false; }
}

/** For tests and for "submit another" on a form that allows it. */
export function forgetSent(formPath: string): void {
  try { localStorage.removeItem(key(formPath)); } catch { /* ignore */ }
}
